import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import Help from "pages/helps";
import Logs from "pages/logs";
import HmtSalesList from "pages/hmt/HmtSalesList";
import HmtPlans from "pages/hmt/HmtPlans";
import BulkOrders from "pages/bulk-orders";

import {
  HelpSharp,
  History,
  AttachMoney,
  ShoppingCart,
  RestaurantMenu,
} from "@mui/icons-material";

const routes = [
  {
    type: "collapse",
    name: "HMT Sales",
    key: "hmt-sales",
    route: "/hmt-sales",
    roles: ["SUPER_ADMIN"],
    icon: <AttachMoney sx={{ fontSize: "1.25rem" }} />,
    component: <HmtSalesList />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "HMT Plans",
    key: "hmt-plans",
    route: "/hmt-plans",
    roles: ["SUPER_ADMIN"],
    icon: <RestaurantMenu size="12px" />,
    component: <HmtPlans />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Bulk Orders",
    key: "bulk-orders",
    route: "/bulk-orders",
    roles: ["SUPER_ADMIN"],
    icon: <ShoppingCart size="12px" />,
    component: <BulkOrders />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Logs",
    key: "logs",
    route: "/logs",
    roles: ["SUPER_ADMIN"],
    icon: <History size="12px" />,
    component: <Logs />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Help",
    key: "helps",
    route: "/helps",
    roles: ["SUPER_ADMIN"],
    icon: <HelpSharp size="12px" />,
    component: <Help />,
    noCollapse: true,
  },
  {
    route: "/login",
    component: <SignIn />,
  },
  {
    key: "dashboard",
    route: "/dashboard",
    component: <Dashboard />,
    roles: ["SUPER_ADMIN"],
  },
  {
    key: "profile",
    route: "/profile",
    component: <Profile />,
    roles: ["SUPER_ADMIN"],
  },
];

export default routes;
